import loader from '../../common/loader';
import cookie from '../../common/cookie';
import network from '../../common/network';
import { loginCookie } from '../login/common';
var jsApi1 = 'https://y.qq.com/lib/commercial/h5/polyfill.min.js?max_age=2592000';
var jsApi2 = 'https://y.qq.com/lib/commercial/h5/music-2.2.0.min.js?max_age=604800';
var qqAppid = '100497308';
var wxAppid = 'wx5aa333606550dfd5';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'music'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve, reject) {
    if (window.Music) {
      resolve(window.Music);
      return;
    }

    loader.loadScript(jsApi1).then(function (isLoad) {
      if (isLoad) {
        loader.loadScript(jsApi2).then(function (isLoad) {
          if (isLoad && window.Music) {
            resolve(window.Music);
          } else {
            reject();
          }
        })["catch"](function (e) {
          reject(e);
        });
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.user.login(function (status) {
      if (status) {
        location.reload();
      }
    }, true, true);
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.user.login({
      loginType: 2,
      forceLogin: true,
      cb: function cb(status) {
        if (status) {
          location.reload();
        }
      }
    });
  })["catch"](function () {});
};

var loginByQQ = function loginByQQ() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.user.login({
      loginType: 1,
      forceLogin: true,
      cb: function cb(status) {
        if (status) {
          location.reload();
        }
      }
    });
  })["catch"](function () {});
};

var setAppCookie = function setAppCookie() {
  return new Promise(function (resolve, reject) {
    var acctype = cookie.get('acctype');
    var quin = cookie.get('uin');
    var qskey = cookie.get('skey');
    var mobileqopenid = cookie.get('psrf_qqopenid');
    var mobileqtoken = cookie.get('psrf_qqaccess_token');
    var wopenid = cookie.get('wxopenid');

    if (acctype) {
      if (acctype === 'wx') {
        network.ajax({
          url: 'https://c.y.qq.com/base/fcgi-bin/login_get_musickey.fcg',
          type: 'get',
          dataType: 'json',
          data: {
            from: '1',
            force: '1',
            wxopenid: wopenid,
            wxrefresh_token: cookie.get('wxrefresh_token'),
            musickey: cookie.get('qm_keyst'),
            get_access_token: 1,
            ct: undefined,
            format: 'json'
          },
          success: function success(data) {
            if (data.code == 0 && data.wxaccess_token) {
              console.log('获取wxaccess_token成功');
              console.log(data.wxaccess_token);
              loginCookie.setLocal({
                acctype: 'wx',
                appid: wxAppid,
                openid: wopenid,
                access_token: data.wxaccess_token
              }, 7200);
              resolve();
            } else {
              // {"servertime":1650852878,"code":1000,"subcode":-40030,"first_login":0,"msg":"failed to refresh_token"}
              resolve({
                errInfo: data,
                miloCode: -40030
              });
            }
          },
          error: function error(e) {
            console.log(e);
            reject();
          }
        });
      } else if (acctype === 'qc') {
        window.iUseQQConnect = 1;
        loginCookie.setLocal({
          acctype: 'qc',
          appid: qqAppid,
          openid: mobileqopenid,
          access_token: mobileqtoken
        }, 7200);
        resolve();
      } else if (acctype === 'pt') {
        loginCookie.setQQ({
          uin: quin,
          skey: qskey
        }, 7200);
        resolve();
      }
    } else {
      reject();
    }
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    var acctype = cookie.get('acctype');

    if (acctype === 'wx') {
      resolve('wx');
    }

    if (acctype === 'qc') {
      resolve('qc');
    }

    if (acctype === 'pt') {
      resolve('pt');
    }

    resolve(null);
  });
};

var logout = function logout() {
  loginCookie.clearLocal();
  loginCookie.clearQQ();
};

var music = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default music;